import Api from '@/services/z-api/v1/api'
import settings from '@/settings'

export default new Api(settings)
